import axios from 'axios';
import { ENDPOINTS } from '../constants/endpoints';
import { AuthService } from '../services/auth.service';
import { HelpLogger } from './types';

/**
 * Replace ids in a path so the missing-help log never carries a record id:
 * `/sales/quotations/3f2a...-uuid/edit` becomes `/sales/quotations/:id/edit`.
 */
export function normalizePath(path: string): string {
    return path
        .split('?')[0]
        .split('#')[0]
        .split('/')
        .map(seg => (/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(seg) || /^\d+$/.test(seg) ? ':id' : seg))
        .join('/');
}

/** Default for tests and previews: logs nothing. */
export const noopHelpLogger: HelpLogger = { logMissing: () => undefined };

/**
 * Sends {key, path} only (V265 help_missing_log keeps no user or institution). HelpProvider already sends each
 * key and page once per session. A failed report is dropped: help must never show an error for this.
 */
export const httpHelpLogger: HelpLogger = {
    logMissing: ({ key, path }) => {
        axios.post(ENDPOINTS.HELP.MISSING, { key, path: normalizePath(path) }, { headers: AuthService.getAuthHeader() })
            .catch(() => undefined);
    },
};
